<div class="section-pageview">

	<div class="page-hero "></div>

	<div class="page-body ">

		<header class="page-header">
		  <div class="container">
			<a class="logo" routerLink="/dashboard">천지성공</a>
		  </div>
		</header>
		
		<div class="loading">
			<img src="http://www.jsd.or.kr/pages/docs/success6/assets/loading.gif" *ngIf="loading"> 
		</div>
		
		<main class="page-container" *ngIf="page">
		
			<section class="heading">
				<div class="container">
					<h2>{{ page.getSubjectStripped() }}</h2>
				</div>
			</section>

			<div class="page-content">
				<div class="container">			
					<div class="content" [innerHTML]="page.content"></div>			
				</div>
			</div>
			
			
			<nav class="pagination">

			  

			  <a class="pagination-next" href="javascript:void(0)" (click)="goBack()" ><strong>뒤로 가기</strong></a>
			  
			  
			  <!--
			  <a class="pagination-next" routerLink="/page/{{ nextpage_uid }}"><strong>다음 글</strong></a>

			  <a class="pagination-next" routerLink="/dashboard"><strong>시작화면 가기</strong></a>
			  
			  <button class="" (click)="goBack()">
					<strong>뒤로 가기</strong>
			  </a>
			  
			  -->
			
		  </nav>
		  
		</main>
		
	</div>
	
</div>